import { TextContainer } from '@components/GeneralHalfSplit/_TextContainer';
import { VideoContainer } from '@components/GeneralHalfSplit/_VideoContainer';
import LazyLoadImage from '@repo/ui/src/components/LazyLoadImage';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { MediaType } from '@repo/ui/src/types/image';
import { LinkProps } from '@repo/ui/src/types/link';
import { YoutubeLinkProps } from '@repo/ui/src/types/youtubeLink';

interface Props {
  title: string;
  header: string;
  description: string;
  image: MediaType;
  splitPosition: string;
  linkDisplay: string;
  link: LinkProps;
  imgOrVideo: string;
  youtubeLink?: YoutubeLinkProps;
  order: number;
  _testID?: string;
}

const GeneralHalfSplit = ({
  title,
  header,
  description,
  image,
  splitPosition,
  linkDisplay,
  link,
  imgOrVideo,
  youtubeLink,
  order,
  _testID,
}: Props) => {
  const imgUrl = buildImageSrc(image, 600, 5, 3);
  return (
    <div
      className="tw-relative tw-flex tw-flex-col tw-justify-center tw-mb-0 tw-margin-auto odd:tw-bg-warm-200 md:tw-flex-row md:odd:tw-flex-row-reverse tw-gap-8 tw-px-6 tw-py-12 md:tw-p-16"
      style={{ zIndex: order }}
      data-test-id={`general_half_split_${_testID}`}
    >
      <div
        className={`tw-mb-3  ${
          splitPosition === 'Text-left_Photo-right' ? 'odd:tw-grid-col-1' : ''
        }`}
      >
        {imgOrVideo === 'Video' && youtubeLink ? (
          <VideoContainer youtubeLink={youtubeLink} />
        ) : (
          <LazyLoadImage
            imgComponent={
              /* eslint-disable-next-line @next/next/no-img-element */
              <img
                className="tw-rounded tw-w-full"
                src={imgUrl}
                alt={image?.name ?? 'image not found'}
              />
            }
          />
        )}
      </div>
      <TextContainer
        title={header || title}
        description={description}
        linkDisplay={linkDisplay}
        linkObj={link}
      />
    </div>
  );
};

export default GeneralHalfSplit;
